import {Modal, Row, Col, message, Upload} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";
import config from "../../../../_core/config";
import {b64DecodeToUrl} from "../../../../utils/helpers";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";

const ExcelUploadModal = ({visibility, id, name, onClose}) => {
    const {t} = useTranslation(["companyDetail", "paymentManagement"]);
    const stores = useStore();
    const [importLoading, setImportLoading] = useState();
    const [uploading, setUploading] = useState(false);
    const fileUploadProps = {
        name: "file",
        multiple: false,
        action: `${config.getReportBasePublicUrl()}api/panel/v1/payment-period/data/import/${id}`,
        headers: {Authorization: "Basic " + stores.meStore.sessionToken},
        showUploadList: false,
        onChange: async info => {
            const {status} = info.file;
            if (status === "uploading") {
                setImportLoading(true);
            }
            if (status === "done") {
                const responseMessages = [];
                let errorExcel = info.file.response.result?.errorExcel;
                if (errorExcel) {
                    responseMessages.push(
                        <div key={"error"}>
                            <b>
                                {t("companyDetail.modal.fileUpload.errorExcel", {
                                    ns: "companyDetail"
                                })}
                            </b>
                        </div>
                    );
                    errorExcel = await b64DecodeToUrl(errorExcel);
                    let link = document.createElement("a");
                    link.href = errorExcel;
                    link.download = `${t("paymentManagement.errorExcelName", {
                        ns: "paymentManagement"
                    })}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(function() {
                        window.URL.revokeObjectURL(link);
                    }, 200);
                    stores.appStore.openErrorModal({
                        title: "Dosya yüklenemedi!",
                        content: ""
                    });
                }
                {
                    !errorExcel &&
                        stores.appStore.openSuccessModal({
                            title: t("paymentManagement.modal.uploadModal.successTitle", {
                                ns: "paymentManagement"
                            }),
                            content: ""
                        });
                }

                setImportLoading(false);
                onClose(true);
            } else if (status === "error") {
                message.error(
                    t("companyDetail.modal.fileUpload.error", {
                        ns: "companyDetail",
                        filename: info.file.name,
                        responseMessage: info.file.response.message
                    })
                );
                setImportLoading(false);
            }
        }
    };

    return (
        <Modal
            title={`Veri Yükle ( ${name} )`}
            visible={visibility}
            onCancel={() => onClose(false)}
            cancalButtonProps={{disabled: importLoading}}
            okButtonProps={{disabled: importLoading}}
            closable={!importLoading}
            onOk={() => onCancel(true)}
            loading={uploading}
            confirmLoading={importLoading}
            okText={t("modal.okButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            <Row>
                <Col span={24}>
                    <Upload {...fileUploadProps} accept=".xlsx,.xls,.csv,.tsv">
                        <CustomButton
                            loading={importLoading}
                            icon={<UploadOutlined />}
                            data-testid="importFromExcelButton"
                        >
                            {t("fields.selectFile", {ns: "common"})}
                        </CustomButton>
                    </Upload>
                </Col>
            </Row>
        </Modal>
    );
};

export default ExcelUploadModal;
